import { COLORS, ERROR_COLOR } from '../../../config/designSystem/Colors';
import { Feather } from '@expo/vector-icons';
import { ParagraphMRegular } from '../../../config/designSystem/typography';
import { SPACING } from '../../../config/designSystem/Spacing';
import { StyleSheet, TouchableOpacity, View } from 'react-native';

interface HealthDashboardErrorProps {
  message: string;
  retryLabel: string;
  onRetry: () => void;
}

export const HealthDashboardError = ({ message, retryLabel, onRetry }: HealthDashboardErrorProps) => {
  return (
    <View style={styles.container}>
      <Feather name="alert-circle" size={48} color={ERROR_COLOR} />
      <ParagraphMRegular color={ERROR_COLOR} align>
        {message}
      </ParagraphMRegular>
      <TouchableOpacity onPress={onRetry} style={styles.retryButton}>
        <ParagraphMRegular color={COLORS.brand[500]}>
          {retryLabel}
        </ParagraphMRegular>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: SPACING['sp-32'],
    gap: SPACING['sp-16'],
  },
  retryButton: {
    marginTop: SPACING['sp-16'],
    padding: SPACING['sp-12'],
  },
});
